// Browsers (Chrome especially) still report legacy IANA aliases such as
// "Asia/Calcutta". Servers whose tzdata ships without the backward-compat
// links reject those, so map them to their canonical names before sending.
const LEGACY_TIMEZONES = {
  'Asia/Calcutta': 'Asia/Kolkata',
  'Asia/Katmandu': 'Asia/Kathmandu',
  'Asia/Saigon': 'Asia/Ho_Chi_Minh',
  'Asia/Rangoon': 'Asia/Yangon',
  'Asia/Dacca': 'Asia/Dhaka',
  'Asia/Thimbu': 'Asia/Thimphu',
  'Asia/Macao': 'Asia/Macau',
  'Asia/Ujung_Pandang': 'Asia/Makassar',
  'Asia/Ulan_Bator': 'Asia/Ulaanbaatar',
  'Asia/Chungking': 'Asia/Shanghai',
  'Asia/Chongqing': 'Asia/Shanghai',
  'Asia/Harbin': 'Asia/Shanghai',
  'Asia/Kashgar': 'Asia/Urumqi',
  'Asia/Ashkhabad': 'Asia/Ashgabat',
  'Asia/Tel_Aviv': 'Asia/Jerusalem',
  'Asia/Istanbul': 'Europe/Istanbul',
  'Europe/Kiev': 'Europe/Kyiv',
  'Europe/Belfast': 'Europe/London',
  'Europe/Nicosia': 'Asia/Nicosia',
  'Africa/Asmera': 'Africa/Asmara',
  'Africa/Timbuktu': 'Africa/Bamako',
  'America/Buenos_Aires': 'America/Argentina/Buenos_Aires',
  'America/Catamarca': 'America/Argentina/Catamarca',
  'America/Cordoba': 'America/Argentina/Cordoba',
  'America/Jujuy': 'America/Argentina/Jujuy',
  'America/Mendoza': 'America/Argentina/Mendoza',
  'America/Rosario': 'America/Argentina/Cordoba',
  'America/Indianapolis': 'America/Indiana/Indianapolis',
  'America/Fort_Wayne': 'America/Indiana/Indianapolis',
  'America/Louisville': 'America/Kentucky/Louisville',
  'America/Knox_IN': 'America/Indiana/Knox',
  'America/Godthab': 'America/Nuuk',
  'America/Montreal': 'America/Toronto',
  'America/Shiprock': 'America/Denver',
  'America/Virgin': 'America/St_Thomas',
  'America/Porto_Acre': 'America/Rio_Branco',
  'America/Ensenada': 'America/Tijuana',
  'America/Santa_Isabel': 'America/Tijuana',
  'Atlantic/Faeroe': 'Atlantic/Faroe',
  'Atlantic/Jan_Mayen': 'Europe/Oslo',
  'Australia/ACT': 'Australia/Sydney',
  'Australia/Canberra': 'Australia/Sydney',
  'Australia/NSW': 'Australia/Sydney',
  'Australia/Victoria': 'Australia/Melbourne',
  'Australia/Queensland': 'Australia/Brisbane',
  'Australia/South': 'Australia/Adelaide',
  'Australia/North': 'Australia/Darwin',
  'Australia/West': 'Australia/Perth',
  'Australia/Tasmania': 'Australia/Hobart',
  'Pacific/Samoa': 'Pacific/Pago_Pago',
  'Pacific/Ponape': 'Pacific/Pohnpei',
  'Pacific/Truk': 'Pacific/Chuuk',
  'Pacific/Yap': 'Pacific/Chuuk',
  'Pacific/Enderbury': 'Pacific/Kanton',
  'US/Eastern': 'America/New_York',
  'US/Central': 'America/Chicago',
  'US/Mountain': 'America/Denver',
  'US/Pacific': 'America/Los_Angeles',
  'US/Alaska': 'America/Anchorage',
  'US/Hawaii': 'Pacific/Honolulu',
  'US/Arizona': 'America/Phoenix',
  'Canada/Eastern': 'America/Toronto',
  'Canada/Central': 'America/Winnipeg',
  'Canada/Mountain': 'America/Edmonton',
  'Canada/Pacific': 'America/Vancouver',
  'Canada/Atlantic': 'America/Halifax',
  'Canada/Newfoundland': 'America/St_Johns',
  'Brazil/East': 'America/Sao_Paulo',
  'Singapore': 'Asia/Singapore',
  'Hongkong': 'Asia/Hong_Kong',
  'Japan': 'Asia/Tokyo',
  'Israel': 'Asia/Jerusalem',
  'Turkey': 'Europe/Istanbul',
  'Egypt': 'Africa/Cairo',
  'Iran': 'Asia/Tehran',
  'NZ': 'Pacific/Auckland',
  'GB': 'Europe/London',
  'Eire': 'Europe/Dublin',
};

export function getUserTimezone() {
  let timezone;
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    timezone = null;
  }
  if (!timezone) return 'UTC';
  return LEGACY_TIMEZONES[timezone] || timezone;
}
